import React from "react"

export default function FooterFiveColsLogoSubFooter() {
  return (
    <>
      {/*    <!-- Component: Five Columns Footer with Logo and Sub Footer --> */}
      <footer className="w-full border-0 absolute bottom-0 ">
        {/*      <!-- Main footer --> */}
        
       <p className="text-center">Find alt coin gems : <a  href="https://moralismoney.com">money.moralis.io</a></p>
      </footer>
      {/*    <!-- End Five Columns Footer with Logo and Sub Footer --> */}
    </>
  )
}